<template>
  <div class="article">
    <bread-crumb></bread-crumb>
    <div class="wrap">
      <!-- 作者信息 -->
      <audit-info :originalAuthor="form.originalAuthor" />
      <!-- 分栏 -->
      <c-title title="基本内容" />
      <!-- 标题 -->
      <Title :articleType="articleType" :title.sync="form.title" />
      <!-- 摘要(运营端视频不显示摘要) -->
      <Summary v-if="form.articleType != 7" :summary.sync="form.summary" />
      <!-- 视频播放 -->
      <video-play-man :functionIds="{ getArticleByPid: 'health_cmp_biz_manQueryArticleById' }"
        v-if="form.articleType == 7" :form.sync="form" ref="manVideoRef" />
      <!-- 封面图 -->
      <upload-poster-image :form.sync="form" v-if="form.articleType == 7" ref="uploadPosterImgRef"
        :functionIds="{ setVideoCover: 'health_cmp_biz_setVideoCover' }" />

      <!-- 上传封面图组件 -->
      <upload-image @change-title-pic="changeTitlePic" :data="form.titlePicUrl" />
      <!-- 敏感词 -->
      <sensitive-words :sensitiveWords.sync="form.sensitiveWords" />
      <!-- 富文本编辑器 -->
      <div class="content-item flex">
        <p class="content-item-label"><span class="red">*</span>{{ form.articleType == 7 ? "视频简介" : "正文" }}</p>
        <c-editor ref="editorRef" :content.sync="form.content" index="1" @getLength="getLength" @getEditor="getEditor" />
      </div>
      <!-- 视频内容同步 -->
      <div class="content-item flex" v-if="form.articleType == 7 && form.contentExtend" style="display: flex; align-items: center;">
        <p class="content-item-label">内容同步</p>
        <!-- 审核等情况下不可改变是否内容同步 -->
        <el-checkbox 
          v-model="form.contentExtend.syncToJdDr"
          disabled=true
          style="display: flex; align-items: center;">
          同步到京东
        </el-checkbox>
      </div>
      <!--基本信息-->
      <article-basic 
        :articleSource.sync="form.articleSource" 
        :articleType.sync="form.articleType"
        :resArticleType="res.articleType" 
        :words.sync="words" 
        :articelId.sync="form.id"
        :articelRadio.sync="res.contentAttributes" 
        :floorType="floorType" 
        :articleOriginality="articleOriginality"
        :originalityCheckTime="originalityCheckTime" 
        :articleOriginalityText="articleOriginalityText"
        :articleIndex.sync="contentIndexes" 
        @repeatGetRecord="saveOrUpdateArticles" 
        @indexChange="indexChange"
        @canShareChange="canShareChange"
        :canShare="form.canShare"
        :title="form.title" 
        :content="form.content" 
        :resForm="form" 
        :textLength="textLength" 
        :editorEdit="editorEdit"
        ref="articleBasic"
      >
        <reprinted-from v-if="form.articleSource == 2" :reprintedFrom.sync="form.reprintedFrom" />
        <!-- 原文发布时间 -->
        <div class="content-item flex"  v-if="form.articleSource == 2" >
          <p class="content-item-label">原文发布时间</p>
          <el-date-picker
            size="small"
            type="datetime"
            v-model="form.originalPublishTime"
            placeholder="请输入原文发布时间"
          >
          </el-date-picker>
        </div>
      </article-basic>
      <!-- 分栏 -->
      <c-title
        has-margin="true"
        title="标签信息"
        showModel="true"
        @clickOnceApply="clickOnceApply"
        @largeModelRefresh="largeModelRefresh"
        :showEmpty = "showEmpty"
        :loadingTip = "loadingTip"
        :isLoading = "isLoading"
      />
          <!-- 运营标签 -->
          <article-label
            :articleId="form.id"
            :labelType="$route.query.tenantid == '287' ? 1 : undefined"
            :functionIds="{ getArticleLabel: 'health_cmp_biz_pageAuditLabels' }"
            ref="labelRef"
            :largeModelLabelBizDTOS="articelLargeModelLabelBizDTOS"
          />
          <!-- 疾病标签 -->
          <disease-label
            :data="form.diseaseLabels"
            @changeDiseaseLabels="changeDiseaseLabels"
            :functionIds="{ getDiseases: 'health_cmp_pageDiseaseInfoByParam' }"
            :largeModelLabelBizDTOS="disLargeModelLabelBizDTOS"
            ref="diseaseRef"
          />
          <!-- 症状标签 -->
          <symptom-label
            :csdata="form.contentSymptoms"
            @changeSymptomLabels="changeSymptomLabels"
            :functionIds="{ getSymptom: 'health_cmp_pageSymptomByName' }"
            :largeModelLabelBizDTOS="symlargeModelLabelBizDTOS"
            ref="symptomRef"
          />
          <source-label
            v-if="form.articleType == 7"
            :data="form.extensionContentLabels"
            @changeSourceLabels="changeSourceLabels"
            ref="sourceRef"
            :labelType="$route.query.tenantid == '287' ? 1 : undefined"
            :functionIds="{ getArticleLabel: 'health_cmp_biz_pageAuditLabels' }"
          ></source-label>
          <!-- 类目标签 -->
          <category-label
            :data="form.categorys"
            @changeCategoryLabels="changeCategoryLabels"
            :functionIds="{ getCategorys: 'health_cmp_queryCategoryByIds' }"
            :largeModelLabelBizDTOS="cateLargeModelLabelBizDTOS"
            ref="categoryRef"
          />
          <!-- 商品标签 -->
          <content-skus-label :data="form.contentSkus" @changeContentSkusLabels="changeContentSkusLabels"
            :functionIds="{ getContentSkus: 'health_cmp_biz_querySkus' }" />
          <!-- drug id标签 -->
          <Drug-id-label 
            :data="form.contentDrugs"
            @changeEncyclopediaLabels="changeEncyclopediaLabels"
            :is-show-encyclopedia="isShowEncyclopedia"
            :functionIds="{
              queryEncyclopedia: 'health_cmp_biz_manPageDrugInfoByParam'
            }"/>
          <!-- 常用名  -->
          <Generic-name-label
            :data="form.contentDrugNames"
            @changeGenericNameLabels="changeGenericNameLabels"
            :is-show-encyclopedia="isShowEncyclopedia"
            :functionIds="{
              queryEncyclopedia: 'health_cmp_biz_queryDrugGenericNames'
            }"/>
          <!-- 搭配品 -->
          <collocation-skus v-if="form.articleType == 7" :data="form.contentSkus" @changeCollocationSkus="changeCollocationSkus"
            :functionIds="{ getContentSkus: 'health_cmp_biz_querySkus' }" />
          <!-- </div> -->
      <!-- 分栏 -->
      <c-title has-margin="true" title="原始作者" />
      <!-- 原始作者 -->
      <original-author :functionIds="{ getOriginalAuthors: 'health_cmp_listByDoctorName' }"
        ref="OriginalAuthorRef" />

    </div>
    <!-- 底部按钮组 -->
    <div class="finish-btns">
      <!-- 如果是已经发布过的，运营人员修改之后代替写手发布，并且发布之后审核自动通过 -->
      <el-button :disabled="requesting" type="primary" @click="saveOrUpdateArticles(2, 'publish-again')"
        v-if="[4, 5].indexOf(res.articleStatus) > -1">
        <span>再次发布</span>
      </el-button>
      <el-button :disabled="requesting" type="primary" @click="saveOrUpdateArticles(3, 'pass')" v-if="!actionType">
        <span>通过</span>
      </el-button>
      <el-button @click="rejectClick" v-if="!actionType">
        <span>驳回</span></el-button>
      <el-button :disabled="requesting" @click="saveOrUpdateArticles(form.articleStatus, 'review')" v-if="actionType">
        <span>保存</span></el-button>
      <el-button :disabled="requesting" @click="saveOrUpdateArticles(4, 'man-preview')">
        <span>预览</span>
      </el-button>
    </div>
    <!-- 预览弹窗 -->
    <preview-modal :mUrl.sync="mUrl" :dialogPreVisible.sync="dialogPreVisible" :qrCode="qrCode" />
    <!-- 驳回弹窗 -->
    <reject-modal :rejectForm.sync="rejectForm" @rejectClickHandler="rejectClickHandler" />
  </div>
</template>
<script>
// 工具
import { getQRCode, form_bak } from '@/utils/tools';
import { request } from '@/utils/axios';
import { mapState } from "vuex";
// 文章查重下个版本再整合到组件中去------------------------
import {
  queryContentRiskControl,
  executeContentRiskControl,
  queryLargeModelLabel,
  queryRefreshLMLabel
} from "@/api/man";
// 子组件
import breadCrumb from "@/components/breadCrumb";
import AuditInfo from '@/components/customize/AuditInfo';
import CTitle from '@/components/customize/CTitle';
import Title from '@/components/input/Title';
import Summary from '@/components/textarea/Summary';
import VideoPlayMan from '@/components/palyer/VideoPlayMan';
import uploadPosterImage from "@/components/upload/uploadPosterImage";
import uploadImage from "@/components/upload/uploadImage";
import CEditor from '@/components/editor/CEditor';
import SensitiveWords from '@/components/input/SensitiveWords';
import ArticleSource from '@/components/radio/ArticleSource';
import ReprintedFrom from '@/components/combination/ReprintedFrom';
import ArticleLabel from '@/components/select/ArticleLabel';
import SymptomLabel from '@/components/combination/SymptomLabel';
import SourceLabel from '@/components/combination/SourceLabel';
import DiseaseLabel from '@/components/combination/DiseaseLabel';
import CategoryLabel from '@/components/combination/CategoryLabel';
import DrugIdLabel from '@/components/combination/DrugIdLabel';
import GenericNameLabel from '@/components/combination/GenericNameLabel';
import ContentSkusLabel from '@/components/combination/ContentSkusLabel';
import CollocationSkus from '@/components/combination/CollocationSkus';
import OriginalAuthor from '@/components/select/OriginalAuthor';
import PreviewModal from "@/components/pop/PreviewModal";
import RejectModal from "@/components/pop/RejectModal";
import ArticleBasic from "../../../../components/radio/ArticleBasic";
import utils from "../../../../utils";
// import { async } from 'q';

const baseUrl = process.env.VUE_APP_BASEURL;
export default {
  data() {
    return {
      imgHost: "//image.healthjd.com/da/",
      // 查询文章接口返回的原始数据
      res: {},
      // 控制按钮在不同的文章状态下的显示逻辑使用的，该字段从url中获取，由列表页编辑，添加等按钮带过来的
      actionType: "",
      // 驳回弹窗
      rejectForm: {
        rejectlineDialog: false,
        rejectReasons: "",
        isShowBtn: [true, true], //弹窗是否能显示按钮
        ordinaryBtnText: ["取消", "确认"]
      },
      contentIndexes: [],
      // 预览弹框是否显示
      dialogPreVisible: false,
      // 预览弹框二维码
      qrCode: "",
      // 预览弹框文章链接
      mUrl: "",
      // 公共表单
      form: this.$commonJs.deepClone(form_bak),
      // 封面图
      titlePicUrl: [],
      // 点击保存，发布，通过等最下面的按钮请求状态。防止重复提交
      requesting: false,
      baseUrl,
      // 富文本文字数量
      textLength: '',
      editorEdit: {},
      // contentSkusList: [] // 回显-商品sku
      symlargeModelLabelBizDTOS: [], // 症状大模型
      disLargeModelLabelBizDTOS: [], // 疾病大模型
      cateLargeModelLabelBizDTOS: [], // 类目大模型
      articelLargeModelLabelBizDTOS: [], // 通用标签
      loading: true,
      showEmpty: false,
      loadingTip: '大模型加载中...',
      largeTimer: '',
      largeTimeValue: 0,
      isLoading: true,
      modelUpdateTime:'',
      modelIsUpdate: false,
    };
  },
  components: {
    ArticleBasic,
    breadCrumb,
    uploadPosterImage,
    uploadImage,
    AuditInfo,
    CTitle,
    Title,
    Summary,
    VideoPlayMan,
    CEditor,
    SensitiveWords,
    // eslint-disable-next-line vue/no-unused-components
    ArticleSource,
    SymptomLabel,
    SourceLabel,
    ReprintedFrom,
    ArticleLabel,
    DiseaseLabel,
    CategoryLabel,
    DrugIdLabel,
    GenericNameLabel,
    ContentSkusLabel, // 商品
    CollocationSkus,
    OriginalAuthor,
    PreviewModal,
    RejectModal,
  },
  watch: {
    "form.articleSource"(newVal, oldVal) {
      if (newVal !== 2) {
        this.form.reprintedFrom = "";
        this.form.originalPublishTime="";
      }
    }
  },
  created() {
    if (this.$route.query.articleType) {
      this.form.articleType = this.$route.query.articleType;
      this.actionType = this.$route.query.actionType;
    }
    // 如果是编辑文章
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id;
      this.searchArticleById();
    }
    this.floorType = this.$route.query.requestSource;

    this.queryLargeModelLabel();
  },
  computed: {
    // 计算属性的 getter
    ...mapState(["isShowOriginalAuthor"])
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.cancel, false);
    }
    setTimeout(() => {
      // 添加这段代码
      const $el = document.querySelectorAll('.el-cascader-node[aria-owns]');
      console.log($el);
      Array.from($el).map((item) => item.removeAttribute('aria-owns'));
    }, 300);
  },
  destroyed() {
    window.removeEventListener('popstate', this.cancel, false);
    clearTimeout(this.largeTimer);
  },
  methods: {
    canShareChange(val){
      this.form.canShare = val;
    },
    // 同步状态切换
    handleSyncChange(val){
      console.log(val)
    },
    // 症状标签
    changeSymptomLabels(data) {
      console.log("🚀 ~ file: index.vue:228 ~ changeSymptomLabels ~ data:", data)
      this.form.contentSymptoms = data;
    },
    // 来源标签
    changeSourceLabels(data) {
      console.log("🚀 ~ file: index.vue:228 ~ changeSourceLabels ~ data:", data)
    //   this.form.extensionContentLabels.push(data);
    },
    changeEncyclopediaLabels(data) {
      this.form.contentDrugs = data;
    },
    changeGenericNameLabels(data) {
      console.log("=======!",data)
      this.form.contentDrugNames = data;
    },
    // 获取富文本长度
    getLength(val) {
      this.textLength = val
    },
    getEditor(val) {
      this.editorEdit = val
    },
    cancel: function () {
      this.$router.push(this.$route.query.taskFlag ? `/contentAudit/task` : `/contentAudit/content`)
      this.hopStorage();
    },
    hopStorage() {
      // 跳转列表页存储状态
      sessionStorage.setItem('content', 1)
    },
    /**
     * @desc 由于某些特殊字段，无法使用vue v-model绑定操作，需要js手工赋值，故在保存，预览，提交，发布，审核文章前初始化一些表单的数据,比如上传图片，视频等信息
     * @param val  文章状态值 user端：0:第一次创建预览 1:草稿，2:发布，man端：3:保存文章，4:预览，5:通过
     * @param opt_type  user端：draft:'草稿'，preview:'预览'，publish:'发布'，man端： pass:'审核'，man-preview:'预览'，review:'保存文章'
     */
    initFormBeforeAddOrUpdate(val, opt_type) {
      this.form.tenantId = this.$commonJs.getTenantId();
      //根据按钮状态修改articleStatus值 bugfix: 预览接口报异常 写手端预览时文章状态和草稿状态一致，但是MAN端预览文章状态不变。
      this.form.articleStatus = "man-preview" == opt_type ? this.form.articleStatus : val;
      // 富文本编辑器标识 0 未知 1 PC1.0 2 PC2.0 3 APP1.0
      this.form.userAgent = 2;
      //封面图校验
      if (this.titlePicUrl && this.titlePicUrl.length) {
        let url = this.titlePicUrl[0].url;
        this.form.titlePicUrl = url.replace(this.imgHost, "");
      }
      //正文校验
      this.form.content = this.$refs.editorRef.editor.getContent();
      // 索引
      if (this.contentIndexes.length > 0) {
        this.form.contentIndexes = [{ indexId: this.contentIndexes[this.contentIndexes.length - 1] }];
      }
      // 获取业务栏目频道标签数据
      // this.$refs.businessColumnChannel.getBizListData(this.form);
      // 原始作者传NULL，代表删除操作， 空对象{}代表第一次创建的时候数据没有数据，传空对象后台自动设置原始作者为自己。
      this.form.originalAuthor = this.form.id ? null : {};
      this.form.originalAuthor = this.$refs.OriginalAuthorRef.mapAuthorOptions()
      // 原始作者 后台数据返回多余字段，在保存提交的时候如果将这些多余字段回传给后台，接口会报错，故这里删除多余字段，
      // user端和man端的多余字段还不太一样，此处需要后台对接口进行优化 backend TODO
      this.form.originalAuthor && this.deleteManProtype(this.form.originalAuthor);
      // this.form.contentLabels && this.form.contentLabels.forEach(item => {
      //   this.deleteManProtype(item);
      // });
      // 处理标签数据
      this.$refs.labelRef?.getFormLabelData(this.form);
      this.$refs.sourceRef?.getFormLabelData(this.form);
    },
    /**
     * @desc 保存，预览，提交，发布，审核文章的检查函数
     * @param val  文章状态值 user端：0:第一次创建预览 1:草稿，2:发布，man端：3:保存文章，4:预览，5:通过
     * @param opt_type  user端：draft:'草稿'，preview:'预览'，publish:'发布'，man端： pass:'审核'，man-preview:'预览'，review:'保存文章'
     * @return true: 表单检查通过， false: ....
     */
    checkBeforeAddOrUpdate(val, opt_type) {
      // man端保存文章 和 user端
      //保存文章状态不变
      if (!this.form.title) {
        this.$message.error("文章标题不能为空");
        return false;
      }
      // 索引选择必选
      if (this.form.contentIndexes.length === 0) {
        this.$message.error("请选择内容索引");
        return false;
      }
      // 视频文章
      if (this.form.articleType == 7) {
        if (!this.form.articleVideoInfos || this.form.articleVideoInfos.length === 0) {
          this.$message.error("可能是老数据或者错误数据导致的问题，请驳回让写手重新编辑！");
          return false;
        }
        if (!this.form.articleVideoInfos[0].imageUrl) {
          // man 端审核通过操作, 需要检查
          if (opt_type == "pass") {
            this.$message.error("视频封面不能为空");
            return false;
          }
        }
      }
      //封面图校验
      if (!this.titlePicUrl || !this.titlePicUrl.length) {
        //bugfix: 保存草稿和预览不效验封面图( 草稿 null 草稿 ) 除运营外 写手视频外 都不效验封面图
        this.$message.error("请上传封面图");
        return false;
      }

      if (!this.form.content) {
        this.$message.error("文章内容不能为空");
        return false;
      }

      // 文章出处
      if (this.form.articleSource == 0 || !this.form.articleSource) {
        this.$message.error("请选择文章出处");
        return;
      }
      //bugfix: 写手端 发布需要效验转载 预览和保存草稿不需要效验 运营端 都需要效验转载字段
      if (this.form.articleSource == 2 && this.form.reprintedFrom == "") {
        this.$message.error("请填写转载文章出处");
        return false;
      }
      return true;
    },
    getPreviewInfoByIdForPin(id, urlPre) {
      let urlAddress = '//beta-api.m.jd.com'
      let devUrl = 'https://cont-yf.jd.com/content/' // 疾病症状预发地址
      let onlineUrl = 'https://cont.jd.com/content/'
      let newUrl;
      if (this.baseUrl === urlAddress) { // 预发
        newUrl = devUrl;
      } else {
        newUrl = devUrl;
      }
      newUrl = newUrl + urlPre + id;
      this.mUrl = newUrl
      getQRCode(this.mUrl, (url) => {
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },
    indexChange(val) {
      this.contentIndexes = val;
    },
    // 格式化传递给后端的 症状库 数据，因为后端不能传symptomName; type 1 添加str， 2 去掉str
    formatSymptomData(data, type) {
      const arr = [];
      data.forEach((item) => {
        console.log("🚀 ~ file: index.vue:230 ~ data.forEach ~ item:", item, type)
        const tmpObj = {}
        tmpObj.symptomId = item.symptomId;
        if (type === 1) {
          tmpObj.symptomNameStr = item.symptomName;
        }else {
          tmpObj.symptomName = item.symptomNameStr
        }
        arr.push(tmpObj);
      });
      console.log("🚀 ~ file: index.vue:374 ~ formatSymptomData ~ arr:", arr)
      return arr;
    },
    // 保存
    saveOrUpdateArticles(val, type) {
      this.initFormBeforeAddOrUpdate(val, type);
      if (!this.checkBeforeAddOrUpdate(val, type)) {
        // 还原文章状态，因为操作没有成功。
        if (this.res && this.res.articleStatus) {
          this.form.articleStatus = this.res.articleStatus;
        }
        return;
      }
      if (!utils.copyPictureCheck(this.form.content, this)) return;

      this.requesting = true;
      let params;
      if (type == "pass") {
        params = {
          tenantId: Number(this.$commonJs.getTenantId()),
          title: this.form.title,
          id: this.form.id,
          viceTitle: this.form.viceTitle,
          titlePicUrl: this.form.titlePicUrl,
          summary: this.form.summary,
          content: this.form.content,
          articleType: this.form.articleType,
          // MAN端审核状态由接口manPassArticle修改，updateArticleByPid只修改文章状态以外的字段。
          articleStatus: undefined,
          userAgent: this.form.userAgent,
          articleSource: this.form.articleSource,
          reprintedFrom: this.form.reprintedFrom,
          originalPublishTime: this.form.originalPublishTime,
          diseaseLabels: this.form.diseaseLabels || null,
          categorys: this.form.categorys || null,
          contentSkus: this.form.contentSkus || null, // 商品
          originalAuthor: this.form.originalAuthor || null,
          articleLevel: this.form.articleLevel,
          articleVideoInfos: this.form.articleVideoInfos || null, //视频审核字段
          contentIndexes: this.form.contentIndexes, // 索引字段
          extensionContentLabels: this.form.extensionContentLabels,
          canShare: this.form.canShare
        };
      } else {
        params = this.$commonJs.deepClone(this.form);
      }
      params.contentSymptoms = this.formatSymptomData(this.form.contentSymptoms, 1), //  症状
      params.contentDrugs = this.form.contentDrugs
      params.contentDrugNames = this.form.contentDrugNames?.map(item => ({
          drugGenericName: item.genericName
      }));
      console.log("======1",params.contentDrugs,params.contentDrugNames)

      params.originalAuthorPin = this.form.originalAuthor
        ? this.form.originalAuthor.originalAuthorPin
        : null;
      params.originalAuthorId = this.form.originalAuthor
        ? this.form.originalAuthor.originalAuthorId
        : null;
      params.originalAuthorType = this.form.originalAuthor
        ? this.form.originalAuthor.originalAuthorType
        : null;
      params.contentAttributes = this.$refs.articleBasic.dataProcessing()
      params.contentIndexes = this.form.contentIndexes; // 索引字段
      if (type == "review") {
        params.extensionContentLabels = this.form.extensionContentLabels;
      }
      console.log("params", params)
      // request('health_cmp_updateArticleByArticleId', params)
      // return;
      request('health_cmp_biz_manUpdateArticle', params)
        .then(res => {
          this.form.id = res.id;
          // pass:'审核'，man-preview:'预览'，review:'保存文章'
          if (type == "review") {
            // 保存文章
            this.$message.success("文章保存成功");
            this.$router.push(this.$route.query.taskFlag ? `/contentAudit/task` : `/contentAudit/content`);
          } else if (type == "man-preview") {
            // 预览
            this.dialogPreVisible = true;
            this.getPreviewInfoByIdForPin(this.form.id, 'preview/');
          } else if (type == "pass") {
            // 审核
            request('health_cmp_biz_manPassArticle', {
              tenantId: this.$commonJs.getTenantId(),
              articleId: this.$route.query.id
            })
              .then(res => {
                this.hopStorage()
                this.$message.success("文章审核通过");
                // 跳转到文章编辑页面
                this.$router.push(this.$route.query.taskFlag ? `/contentAudit/task` : `/contentAudit/content`);
              })
              .catch(error => {
                console.log(error);
                if (error && error.code === "0022") {
                  this.$message.error(error.msg);
                }
              });
          } else if (type == "publish-again") {
            this.hopStorage()
            this.$message.success("再次发布成功！");
            this.$router.push(this.$route.query.taskFlag ? `/contentAudit/task` : `/contentAudit/content`);
          } else if (type == 'riskSave') {
            this.executeContentRiskControl(this.form.id, this.$commonJs.getTenantId());
          }
        })
        .catch(error => {
          console.log(error);
          if (error && error.code == "0309") {
            this.$message.error(error.msg);
          } else {
            this.$message.error(error.msg || "操作失败！");
          }
        })
        .finally(() => {
          this.requesting = false;
        });
    },
    // 搜索商品
  //   async queryContentSkus(list) {
  //     request('health_cmp_biz_querySkus', {
  //       skuIds: list
  //     }).then( async res => {
  //       if (res && res.length) {
  //         this.contentSkusList = res;
  //       } else {
  //         this.contentSkusList = [];
  //       }
  //     }).catch(err => {
  //       console.log(err);
  //       // this.$message.error('获取商品sku失败!');
  //     })
  //   // }
  // },
  searchArticleById(CB) {
    return new Promise((resolve, reject) => {
      request('health_cmp_biz_manQueryArticleById', {
        id: this.form.id,
        tenantId: this.$commonJs.getTenantId()
      }).then(res => {
        console.log("resresres", res)
        const skuList = [];
        res.contentSkus?.forEach(item => {
          skuList.push(item.skuId);
        })
        // this.queryContentSkus(skuList);
        // 暂存接口返回数据
        this.res = res;
        const { contentRiskControls } = res;
        let arr = []
        contentRiskControls && contentRiskControls.length > 0 && contentRiskControls.map((val) => {
          arr.push(val.sensitiveWord)
        })
        const sensitiveWordsStr = arr.length > 0 ? arr.join(',') : '';

        // 置空原始作者外层信息
        this.emptyInfo(res);
        if (res.originalAuthor) {
          this.deleteManProtype(res.originalAuthor);
        }
        if (res.contentLabels) {
          delete res.contentLabels;
        }
        this.form = Object.assign(this.$commonJs.deepClone(form_bak), res);
        // this.form.contentSkus = this.contentSkusList;
        // 症状数据回显
        if (res.contentSymptoms) {
          this.form.contentSymptoms = this.formatSymptomData(res.contentSymptoms, 2);
          console.log("🚀 ~ file: index.vue:535 ~ returnnewPromise ~ this.form.contentSymptoms:", this.form.contentSymptoms)
        }
        if (res.contentDrugs) {
          this.form.contentDrugs = res.contentDrugs
          console.log("🚀 ~ file: index.vue:535 ~ returnnewPromise ~ this.form.contentDrugs:", this.form.contentDrugs)
        }
        if (res.contentDrugNames) {
          this.form.contentDrugNames = res.contentDrugNames.map((item) => ({
              genericName: item.drugGenericName,
          }));
          // contentDrugNames.map(item => ({drugGenericName
          console.log("🚀 ~ file: index.vue:535 ~ returnnewPromise ~ this.form.contentDrugNames:", this.form.contentDrugNames)
        }
        this.words = res.words;
        this.form.sensitiveWords = sensitiveWordsStr
        const treeToArrObj = (obj) => {
          if (!obj.contentIndexes || obj.contentIndexes.length === 0) {
            return { indexId: obj.indexId };
          }
          treeToArrObj(obj.contentIndexes[0]);
        }
        const treeToArr = (obj, arr) => {
          if (obj && obj.indexId) {
            arr.push(obj.indexId);
            treeToArr(obj.contentIndexes[0], arr);
          }
          if (!obj || !obj.contentIndexes || obj.contentIndexes.length === 0) {
            return arr;
          }
        }
        if (res?.contentIndexes?.length > 0) {
          const arr = [];
          treeToArr(res.contentIndexes[0], arr)
          this.form.contentIndexes = [treeToArrObj(res.contentIndexes[0])];
          this.contentIndexes = arr;
        }
        //插入编辑器内容
        // this.$refs.editorRef && this.$refs.editorRef.editor.setContent(this.form.content);
        // 原始作者回显 返显示原作者 bugfix: 和产品确认 运营端原作者字段全部禁止编辑
        if (res.originalAuthor) {
          this.$refs.OriginalAuthorRef.authorOptions = [res.originalAuthor];
          this.$refs.OriginalAuthorRef.selectOriginalAuthorId = res.originalAuthor.originalAuthorId
          // res.originalAuthor.originalAuthorName +
          // " " +
          // res.originalAuthor.originalAuthorTitle +
          // " " +
          // res.originalAuthor.originalAuthorUnit +
          // " " +
          // res.originalAuthor.originalAuthorUnit;
        }

        // 如果是视频文章
        if (this.form.articleType == 7) {
          this.$nextTick(() => {
            this.$refs.manVideoRef.displayDataToHtml();
          });
        }
        resolve(this.res)
        CB && CB();
      }).catch(err => {
        console.log(err);
        reject(err)
      });
    })

  },
  // 在置空原始作者外层信息
  emptyInfo(res) {
    delete res.originalAuthorId;
    delete res.originalAuthorPin;
    delete res.originalAuthorType;
  },
  // 调出--审核--驳回--弹窗
  rejectClick() {
    this.rejectForm.rejectlineDialog = true;
  },
  // 驳回弹窗确定按钮
  rejectClickHandler(arg) {
    if (arg === "two") {
      if (this.rejectForm.rejectReasons.length === 0) {
        this.$message.error("驳回理由不能为空");
      } else {
        request('health_cmp_biz_manRejectArticle', {
          tenantId: this.$commonJs.getTenantId(),
          articleId: this.form.id,
          remark: this.rejectForm.rejectReasons
        }).then(res => {
          this.hopStorage()
          this.rejectForm.rejectlineDialog = false;
          this.rejectForm.rejectReasons = ""; //置空驳回原因
          // 跳转到文章编辑页面
          this.$router.push(this.$route.query.taskFlag ? `/contentAudit/task` : `/contentAudit/content`);
        });
      }
    } else {
      this.rejectForm.rejectlineDialog = false;
    }
  },
  changeDiseaseLabels(data) {
    // 拿到疾病标签
    this.form.diseaseLabels = data;
  },
  changeCategoryLabels(data) {
    // 拿到类目标签
    this.form.categorys = data;
  },
  changeContentSkusLabels(data) {
    console.log("🚀 ~ file: index.vue:593 ~ changeContentSkusLabels ~ data:", data, this.form);
    
    // 创建新数据的映射（只包含type为1的数据）
    const newDataMap = new Map();
    data.forEach(item => {
      if (item.type === 1) { // 只处理type为1的数据
        const key = `${item.skuId}_${item.type}`;
        newDataMap.set(key, item);
      }
    });
    
    // 过滤现有数据，只保留存在于新数据中的项（只过滤type为1的数据）
    this.form.contentSkus = (this.form.contentSkus || []).filter(item => {
      if (item.type === 1) { // 只过滤type为1的数据
        const key = `${item.skuId}_${item.type}`;
        return newDataMap.has(key);
      }
      return true; // 非type为1的数据保留
    });
    
    // 添加不存在的新数据（所有数据，不限于type为1）
    data.forEach(item => {
      const key = `${item.skuId}_${item.type}`;
      if (!this.form.contentSkus.some(existing => 
        `${existing.skuId}_${existing.type}` === key)) {
        this.form.contentSkus.push(item);
      }
    });
  },


  changeCollocationSkus(data) {
    console.log("🚀 ~ file: index.vue:593 ~ changeCollocationSkus ~ data:", data, this.form)

     // 创建新数据的映射（只包含type为2的数据）
     const newDataMap = new Map();
    data.forEach(item => {
      if (item.type === 2) { // 只处理type为2的数据
        const key = `${item.skuId}_${item.type}`;
        newDataMap.set(key, item);
      }
    });
    
    // 过滤现有数据，只保留存在于新数据中的项（只过滤type为1的数据）
    this.form.contentSkus = (this.form.contentSkus || []).filter(item => {
      if (item.type === 2) { // 只过滤type为2的数据
        const key = `${item.skuId}_${item.type}`;
        return newDataMap.has(key);
      }
      return true; // 非type为2的数据保留
    });
    
    // 添加不存在的新数据（所有数据，不限于type为2）
    data.forEach(item => {
      const key = `${item.skuId}_${item.type}`;
      if (!this.form.contentSkus.some(existing => 
        `${existing.skuId}_${existing.type}` === key)) {
        this.form.contentSkus.push(item);
      }
    });
  },
  changeTitlePic(data) {
    // console.log('图文的逻辑')
    // console.log(data)
    this.titlePicUrl = data;
  },
  //删除不不要的属性
  deleteManProtype(obj) {
    // man
    // delete obj.id
    delete obj.created;
    delete obj.articleId;
    delete obj.modified;
    delete obj.yn;
  },
  // 查重接口-------------------------------------
  // 主动查重
  executeContentRiskControl(contentId, tenantId) {
    executeContentRiskControl({ contentId, tenantId }).then((res) => {
      if (res) {
        this.$message.success("操作成功！");
        window.location.reload();
      } else {
        this.$message.error("查重失败！");
      }
    })
  },
  // 查重接口-------------------------------------
  clickOnceApply(value) {
      this.$refs.diseaseRef.clickOnceApply(value);
      this.$refs.symptomRef.clickOnceApply(value);
      this.$refs.categoryRef.clickOnceApply(value);
      this.$refs?.labelRef?.clickOnceApply(value);
  },
  largeModelRefresh() {
    console.log('refresh来了------->');
    queryRefreshLMLabel({
      contentId: this.form.id
    }).then((res) => {
         this.showEmpty = true
        if (res) {
          this.largeTimer = setInterval(()=> {
              this.get()
          }, 30000);
        } else {
           console.log('meiyougengduoshuju');
           this.loadingTip = "没有更多标签";
           this.isLoading = false
        }
    });
  },
  queryLargeModelLabel () {
    queryLargeModelLabel({
      contentId: this.form.id
    }).then((res) => {
       if (res?.length > 0) {
          const modelUpdateTime = res[0].largeModelLabelBizDTOS[0]?.updateTime;
          if (!this.modelUpdateTime) {
             this.modelUpdateTime = modelUpdateTime;
          } else {
            if (modelUpdateTime == this.modelUpdateTime) {
               this.modelIsUpdate = false;
               return;
            } else {
               this.modelIsUpdate = true;
               clearTimeout(this.largeTimer);
               this.loadingTip = "标签更新成功";
               this.isLoading = false
               this.symlargeModelLabelBizDTOS = [];
               this.disLargeModelLabelBizDTOS = [];
               this.cateLargeModelLabelBizDTOS = [];
               this.articelLargeModelLabelBizDTOS = [];
               this.modelUpdateTime = modelUpdateTime;
            }
          }
          console.log(modelUpdateTime, 'modelUpdateTime------->');
          res.map((item) => {
             switch (item.labelType) {
              case 1:
                // 疾病
                {
                  const bizDTOS = item.largeModelLabelBizDTOS.map((dzosItem) => {
                    dzosItem.isSelected = false;
                    return dzosItem;
                   })
                // 症状
                this.disLargeModelLabelBizDTOS = bizDTOS;
                }

                break;
              case 2:
                {
              // 根据现有数据进行匹配
              const bizDTOS = item.largeModelLabelBizDTOS.map((dzosItem) => {
                    dzosItem.isSelected = false;
                    return dzosItem;
               })
              // 症状
              this.symlargeModelLabelBizDTOS = bizDTOS;
              }

              break;

              case 6:
                {
              // 根据现有数据进行匹配
              const bizDTOS = item.largeModelLabelBizDTOS.map((dzosItem) => {
                    dzosItem.isSelected = false;
                    return dzosItem;
               })
              // 症状
              this.cateLargeModelLabelBizDTOS = bizDTOS;
              }

              break;

              case 7:
                {
              // 根据现有数据进行匹配
              const bizDTOS = item.largeModelLabelBizDTOS.map((dzosItem) => {
                    dzosItem.isSelected = false;
                    return dzosItem;
               })
              // 症状
              this.articelLargeModelLabelBizDTOS = bizDTOS;
              }

              break;

              default:
                break;
             }
          });
       }
    })
  },
  get() {
        this.largeTimeValue ++;
        console.log(this.largeTimeValue, 'pppppppp');
        // 6
        if (this.largeTimeValue > 6 && !this.modelIsUpdate) {
          clearTimeout(this.largeTimer);
          this.loadingTip = "没有更多标签";
          this.isLoading = false
        } else {
          this.queryLargeModelLabel();
        }
      }
}
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/common/mixin.scss";
@import "@/styles/article_common.scss";

.article {
  @include article_common;

  // 弹窗提示的body样式
  :deep(.el-dialog__body ) {
    padding: 30px 26px 0px 26px !important;
  }

  // 表单Item样式
  .wrap .content-item .content-item-label {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.finish-btns {
  position: fixed;
  text-align: center;
  width: 85%;
  background-color: #FFFFFF;
  bottom: 0;
}
</style>
